module.exports = __webpack_public_path__ + "static/img/avatar.ed0aec65.jpeg";